function sendBody(method) {
    return (method === 'POST' ||
        method === 'PUT' ||
        method === 'PATCH' ||
        method === 'DELETE');
}
const retryBodies = new WeakMap();
export function proxyFetchToApiRoute(proxyPath, baseUrl = process.env.NEXT_PUBLIC_BASE_PATH) {
    return {
        async onRequest({ request }) {
            const url = new URL(request.url);
            const proxyUrl = new URL(window.location.origin);
            proxyUrl.pathname = baseUrl + proxyPath + url.pathname;
            proxyUrl.search = url.search;
            const { getSession } = await import('@side/next-auth/react');
            const session = await getSession();
            if (!session?.accessToken) {
                console.error('[@side/next-tools] Client session not found, throwing error');
                throw new Error('Authentication required');
            }
            request.headers.set('Authorization', `Bearer ${session.accessToken}`);
            if (baseUrl) {
                request.headers.set('X-Side-Origin', baseUrl.replace(/^\//, ''));
            }
            const body = sendBody(request.method) ? await request.blob() : undefined;
            const proxyReq = new Request(proxyUrl, {
                method: request.method,
                body,
                headers: request.headers,
            });
            retryBodies.set(proxyReq, body);
            return proxyReq;
        },
        async onResponse({ request, response }) {
            if (response.status !== 401) {
                return undefined;
            }
            const { getSession } = await import('@side/next-auth/react');
            const session = await getSession({ bypassCache: true });
            if (!session?.accessToken) {
                return undefined;
            }
            const refreshedAuth = `Bearer ${session.accessToken}`;
            if (request.headers.get('Authorization') === refreshedAuth) {
                return undefined;
            }
            const headers = new Headers(request.headers);
            headers.set('Authorization', refreshedAuth);
            return fetch(new Request(request.url, {
                method: request.method,
                body: retryBodies.get(request),
                headers,
            }));
        },
    };
}
